module.exports = __webpack_public_path__ + "img/up1.8cf6d98c.png";